import { useEffect } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { getMe } from "../crud/auth.crud";
import { actions } from "../store/ducks/auth.duck";

function payloadDoMe(body) {
	if (body?.data?.user) return body.data;
	if (body?.user) return body;
	return null;
}

function listaEmpresasAcessiveis(payload) {
	const raw = payload?.empresas_acessiveis;
	if (Array.isArray(raw)) return raw;
	if (Array.isArray(raw?.data)) return raw.data;
	return null;
}

export default function AtualizarSessao() {
	const dispatch = useDispatch();
	const store = useStore();
	const persona = useSelector(({ auth: { user } }) => user?.token_type);
	const autenticado = useSelector(({ auth: { authToken } }) => !!authToken);

	useEffect(() => {
		if (!autenticado || !persona) return;

		getMe(persona)
			.then(({ data }) => {
				const payload = payloadDoMe(data);
				if (!payload?.user) return;

				const lista = listaEmpresasAcessiveis(payload);
				const atual = store.getState().auth.user;
				dispatch(actions.fulfillUser({
					...atual,
					...payload.user,
					...(lista ? { empresas_acessiveis: lista } : {}),
				}));
				if (payload.permissions) {
					dispatch(actions.atualizarPermissoes(payload.permissions));
				}
			})
			.catch(() => {});
	}, [autenticado, persona, dispatch]);

	return null;
}
